import FormattedMessage from 'I18n/components/FormattedMessage';
import { BookIcon, LessonIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { Button } from 'foundations-components/transitional/components/Button';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { useMemo } from 'react';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { MediaCarousel } from '../../media/MediaCarousel';
import { DetailsPageCard } from './DetailsPageCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductOverviewCard({
  casesUrl,
  benefits,
  screenshots,
  setupUrl,
  videoUrl
}) {
  const mediaCarouselItems = useMemo(() => {
    const carouselItems = screenshots.map(s => ({
      type: 'image',
      source: s.imageUrl,
      alt: s.altText ? s.altText : ''
    }));
    if (videoUrl) {
      carouselItems.unshift({
        type: 'video',
        source: videoUrl,
        alt: ''
      });
    }
    return carouselItems;
  }, [screenshots, videoUrl]);
  return /*#__PURE__*/_jsx(DetailsPageCard, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.overviewCard.title"
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(MediaCarousel, {
        items: mediaCarouselItems
      }), /*#__PURE__*/_jsx(Flex, {
        marginBlockStart: "400",
        "data-test-id": "expandable-benefits",
        children: /*#__PURE__*/_jsx(ExpandableText, {
          maxHeight: 80,
          hideButtonCaret: true,
          buttonAlign: "left",
          children: /*#__PURE__*/_jsx(BreakString, {
            children: /*#__PURE__*/_jsx(SanitizedText, {
              body: benefits
            })
          })
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        marginBlockStart: "400",
        children: [casesUrl && /*#__PURE__*/_jsxs(Button, {
          external: true,
          href: casesUrl,
          size: "xs",
          use: "tertiary-light",
          children: [/*#__PURE__*/_jsx(BookIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.overviewCard.caseStudy"
          })]
        }), setupUrl && /*#__PURE__*/_jsxs(Button, {
          external: true,
          href: setupUrl,
          size: "xs",
          use: "tertiary-light",
          children: [/*#__PURE__*/_jsx(LessonIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.overviewCard.setupGuide"
          })]
        })]
      })]
    })
  });
}